import { Instagram, Youtube, Video } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  // Main navigation links
  const mainLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Courses", path: "/courses" },
    { label: "Community", path: "/community" },
  ];

  const secondaryLinks = [
    { label: "Pricing", path: "/pricing" },
    { label: "Support", path: "/support" },
  ];

  return (
    <footer className="relative py-16 px-4 overflow-hidden bg-[hsl(220,30%,8%)]">
      <div className="relative max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Section */}
          <div>
            <Link to="/" className="inline-block mb-4 hover:opacity-80 transition-opacity">
              <div className="h-20 max-w-[280px]">
                {/* NOTE: Logo should be optimized to ~256x160px (2x retina: 512x320px) for footer display */}
                <img
                  src="/assets/whitelogo.png"
                  alt="Klau y Ros"
                  width={256}
                  height={160}
                  loading="lazy"
                  className="h-full w-auto object-contain"
                  style={{ 
                    pointerEvents: "none",
                    backgroundColor: "transparent"
                  }}
                />
              </div>
            </Link>
            <p className="text-muted-foreground">Feel the music. Master the movement.</p>
          </div>

          {/* Navigate Section */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigate</h4>
            <ul className="space-y-3">
              {mainLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Section */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              {secondaryLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Follow Us Section */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-4 mb-6">
              <a
                href="https://www.instagram.com/klauyros?igsh=MWJpc21jdXljNHNncA=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-lg border border-border/50 flex items-center justify-center hover:border-primary transition-colors"
                aria-label="Instagram"
                style={{ borderColor: "hsl(var(--aqua) / 0.3)" }}
              >
                <Instagram className="w-5 h-5" style={{ color: "hsl(var(--aqua))" }} />
              </a>
              <a
                href="https://www.youtube.com/@klauyros"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-lg border border-border/50 flex items-center justify-center hover:border-primary transition-colors"
                aria-label="YouTube"
                style={{ borderColor: "hsl(var(--aqua) / 0.3)" }}
              >
                <Youtube className="w-5 h-5" style={{ color: "hsl(var(--aqua))" }} />
              </a>
              <a
                href="https://www.tiktok.com/@klauyros"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-lg border border-border/50 flex items-center justify-center hover:border-primary transition-colors"
                aria-label="TikTok"
                style={{ borderColor: "hsl(var(--aqua) / 0.3)" }}
              >
                <Video className="w-5 h-5" style={{ color: "hsl(var(--aqua))" }} />
              </a>
            </div>
            <p className="text-sm text-muted-foreground">Join our community of 24k+ dancers</p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-border/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
            <div className="text-sm text-muted-foreground text-center md:text-left">
              <p className="mb-2">© {new Date().getFullYear()} Klau y Ros. All rights reserved.</p>
              <p>
                Powered by <span className="text-primary">Artoverse</span>
              </p>
            </div>
            <a
              href="https://klauyros.artoverse.club/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="theme-button-primary"
                style={{
                  padding: "10px 24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "8px",
                  boxShadow: "0 0 20px rgba(230, 126, 34, 0.3)",
                  transition: "all 0.3s ease",
                }}
              >
                Enter Studio →
              </button>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
